/**
 * Enum with the possible notification UI events.
 */
export enum NotificationEvents {
    Close = 'Close',
    StartDismissing = 'StartDismissing',
    FinishDismissing = 'FinishDismissing',
    PreventDismissing = 'PreventDismissing',
    RemovedFromList = 'RemovedFromList'
}